<template>
  <v-card flat>
    <welcome-banner />
    <v-card flat>
      <v-card-actions class="pa-4">
        <search-bar></search-bar>
      </v-card-actions>
    </v-card>
    <hot-tags />
    <graph-list-links />
    <router-view />
  </v-card>
</template>

<script>
// @ is an alias to /src
import WelcomeBanner from '@/views/home/WelcomeBanner.vue';
import SearchBar from '@/components/SearchBar.vue';
import HotTags from '@/components/HotTags.vue';
import GraphListLinks from '@/views/home/GraphListLinks.vue';

export default {
  name: 'home',
  components: {
    WelcomeBanner,
    SearchBar,
    HotTags,
    GraphListLinks
  }
};
</script>
